'use strict';

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));

var _toConsumableArray2 = _interopRequireDefault(require('@babel/runtime/helpers/toConsumableArray'));

var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));

var _react = _interopRequireWildcard(require('react'));

var _lodash = _interopRequireDefault(require('lodash'));

var _reactComponents = require('../../../../../../react-components');

var _components = require('../../../../components');

var _styles = _interopRequireDefault(require('./styles'));

function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}

function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2['default'])(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}

var SubFiltersContainer = _styles['default'].SubFiltersContainer;

var checkFilters = function checkFilters(_ref) {
    var setToggle = _ref.setToggle,
        subFilters = _ref.subFilters,
        setError = _ref.setError,
        curCat = _ref.curCat;

    var newCurCat = _objectSpread({}, curCat);

    if (
        _lodash['default'].filter(subFilters, undefined).length ===
        _lodash['default'].filter(newCurCat.subFilters, 'required').length
    ) {
        setError(false);
        setToggle(false);
    } else {
        setError(true);
    }
};

var handleSubFilters = function handleSubFilters(_ref2) {
    var value = _ref2.value,
        index = _ref2.index,
        subFilters = _ref2.subFilters,
        setSubFilters = _ref2.setSubFilters,
        curCat = _ref2.curCat,
        setError = _ref2.setError;
    subFilters[index] = value;
    setSubFilters((0, _toConsumableArray2['default'])(subFilters));

    var newCurCat = _objectSpread({}, curCat);

    if (
        curCat &&
        _lodash['default'].filter(subFilters, undefined).length ===
            _lodash['default'].filter(newCurCat.subFilters, 'required').length
    ) {
        setError(false);
    }
};

var SubFilters = function SubFilters(props) {
    var config = props.config,
        query = props.query,
        setQuery = props.setQuery,
        onPriceChange = props.onPriceChange,
        priceFilter = props.priceFilter,
        priceFilterOptions = props.priceFilterOptions,
        _props$showPriceFilte = props.showPriceFilter,
        showPriceFilter = _props$showPriceFilte === void 0 ? true : _props$showPriceFilte;

    var _useState = (0, _react.useState)(null),
        _useState2 = (0, _slicedToArray2['default'])(_useState, 2),
        curCat = _useState2[0],
        setCurCat = _useState2[1];

    var _useState3 = (0, _react.useState)([]),
        _useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
        subFilters = _useState4[0],
        setSubFilters = _useState4[1];

    var _useState5 = (0, _react.useState)(true),
        _useState6 = (0, _slicedToArray2['default'])(_useState5, 2),
        toggle = _useState6[0],
        setToggle = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = (0, _slicedToArray2['default'])(_useState7, 2),
        loaded = _useState8[0],
        setLoaded = _useState8[1];

    var _useState9 = (0, _react.useState)(false),
        _useState10 = (0, _slicedToArray2['default'])(_useState9, 2),
        error = _useState10[0],
        setError = _useState10[1];

    (0, _react.useEffect)(function() {
        setLoaded(true);
    }, []);
    (0, _react.useEffect)(
        function() {
            if (loaded && _lodash['default'].findIndex(subFilters, 'value') !== -1) {
                setQuery({
                    term: query.term,
                    zip: query.zip,
                    subFilters: subFilters,
                });
            }
        },
        [subFilters],
    );
    (0, _react.useEffect)(
        function() {
            if (loaded) onPriceChange(priceFilter);
        },
        [priceFilter],
    );
    (0, _react.useEffect)(
        function() {
            config.categories.map(function(category) {
                if (query.term.replace('%20', ' ').includes(category.name)) {
                    setCurCat(category);

                    if (category.subFilters && subFilters.length === 0) {
                        if (category.multiSelect) {
                            setSubFilters([undefined]);
                        } else {
                            setSubFilters(
                                category.subFilters.map(function(sub) {
                                    return undefined;
                                }),
                            );
                        }
                    }
                }
            });
        },
        [query],
    );
    (0, _react.useEffect)(
        function() {
            var changedCategory = curCat && !query.term.replace('%20', ' ').includes(curCat.name);

            if (changedCategory && loaded) {
                if (curCat.multiSelect) {
                    setSubFilters([undefined]);
                } else {
                    if (curCat.subFilters)
                        setSubFilters(
                            curCat.subFilters.map(function(sub) {
                                return undefined;
                            }),
                        );
                }
            } else {
                if (loaded) setSubFilters(query.subFilters);
            }
        },
        [query.subFilters, query.term],
    );

    if (curCat) {
        var isSubFiltersEmpty = !curCat.subFilters && _lodash['default'].isEmpty(curCat.subFilters);

        return /*#__PURE__*/ _react['default'].createElement(
            SubFiltersContainer,
            {
                className: 'fade-in',
            },
            _lodash['default'].findIndex(curCat.subFilters, 'required') >= 0 &&
                /*#__PURE__*/ _react['default'].createElement(
                    _components.Modal,
                    {
                        title: ''.concat(curCat.name, ' ').concat(config.title),
                        setEnabled: true,
                        toggle: toggle,
                        setToggle: setToggle,
                        height: 'fit-content',
                        width: 'fit-content',
                        closeIcon: false,
                        mattsStyle: true,
                    },
                    /*#__PURE__*/ _react['default'].createElement(
                        'div',
                        {
                            className: 'subfilters-modal-children',
                        },
                        /*#__PURE__*/ _react['default'].createElement(
                            'div',
                            {
                                className: 'subfilters-container',
                            },
                            _lodash['default'].filter(curCat.subFilters, 'required').map(function(subFilter, i) {
                                return /*#__PURE__*/ _react['default'].createElement(_components.SubFilter, {
                                    key: i,
                                    index: i,
                                    value: subFilters[i],
                                    curCat: curCat,
                                    required: true,
                                    error: error,
                                    onChange: function onChange(value) {
                                        return handleSubFilters({
                                            value: value,
                                            index: i,
                                            setQuery: setQuery,
                                            subFilters: subFilters,
                                            setSubFilters: setSubFilters,
                                            query: query,
                                            curCat: curCat,
                                            setError: setError,
                                        });
                                    },
                                    setSubFilters: setSubFilters,
                                    subFilters: subFilters,
                                    subFilter: subFilter,
                                    loaded: loaded,
                                });
                            }),
                        ),
                        error &&
                            /*#__PURE__*/ _react['default'].createElement(
                                'p',
                                {
                                    className: 'error-field',
                                },
                                /*#__PURE__*/ _react['default'].createElement('i', {
                                    className: 'far fa-exclamation-circle',
                                }),
                                'Please fill all required fields.',
                            ),
                        /*#__PURE__*/ _react['default'].createElement(
                            'button',
                            {
                                className: 'subfilters-modal-button',
                                onClick: function onClick() {
                                    return checkFilters({
                                        setToggle: setToggle,
                                        subFilters: subFilters,
                                        setError: setError,
                                        curCat: curCat,
                                    });
                                },
                            },
                            'Go',
                        ),
                    ),
                ),
            showPriceFilter &&
                /*#__PURE__*/ _react['default'].createElement(_reactComponents.SelectField, {
                    value: priceFilter,
                    selectOptions: priceFilterOptions,
                    name: 'value',
                    onChange: function onChange(value) {
                        return onPriceChange(value);
                    },
                }),
            !isSubFiltersEmpty && curCat.multiSelect
                ? /*#__PURE__*/ _react['default'].createElement(_components.SubFilter, {
                      curCat: curCat,
                      isMultiSelect: true,
                      value: subFilters[0],
                      onChange: function onChange(value) {
                          return handleSubFilters({
                              value: value,
                              index: 0,
                              setQuery: setQuery,
                              subFilters: subFilters,
                              setSubFilters: setSubFilters,
                              query: query,
                          });
                      },
                      loaded: loaded,
                      subFilter: subFilters,
                      index: 0,
                      setSubFilters: setSubFilters,
                      subFilters: subFilters,
                  })
                : curCat.subFilters &&
                      curCat.subFilters.map(function(subFilter, i) {
                          return /*#__PURE__*/ _react['default'].createElement(_components.SubFilter, {
                              key: i,
                              value: subFilters[i],
                              curCat: curCat,
                              onChange: function onChange(value) {
                                  return handleSubFilters({
                                      value: value,
                                      index: i,
                                      setQuery: setQuery,
                                      subFilters: subFilters,
                                      setSubFilters: setSubFilters,
                                      query: query,
                                  });
                              },
                              subFilter: subFilter,
                              loaded: loaded,
                              index: i,
                              setSubFilters: setSubFilters,
                              subFilters: subFilters,
                          });
                      }),
        );
    }

    return /*#__PURE__*/ _react['default'].createElement('div', null);
};

var _default = SubFilters;
exports['default'] = _default;
